// Hana — the words, each one arriving as it is sung.
(function () {
  const H = window.HANA;
  const { clamp, smooth } = H;
  const L = H.Lyrics = {};
  const glowWords = new Set((H.text('glow') || []).map(w => w.toLowerCase()));

  L.init = function (root) {
    const lines = H.text('lyrics') || [];
    L.lines = lines.map((ln, i) => {
      const words = ln.line.split(/\s+/).filter(Boolean);
      const next = lines[i + 1];
      let w = Array.isArray(ln.w) && ln.w.length === words.length ? ln.w.slice() : null;
      if (!w) {
        // words were edited: spread them evenly over the line
        const span = Math.max(1.2, Math.min(4, (next ? next.at : ln.at + 4) - ln.at - 0.4));
        w = words.map((_, j) => ln.at + span * j / Math.max(1, words.length));
      }
      const last = w[w.length - 1];
      const end = Math.min(next ? next.at - 0.15 : Infinity, last + 3.2);
      const p = document.createElement('p');
      const spans = words.map(word => {
        const s = document.createElement('span');
        s.textContent = word;
        if (glowWords.has(word.toLowerCase().replace(/[^\p{L}']/gu, ''))) s.className = 'glow';
        s.style.opacity = '0';
        p.appendChild(s);
        return s;
      });
      p.style.display = 'none';
      root.appendChild(p);
      return { at: w[0], w, end, p, spans, cache: [] , shown: false };
    });
  };

  L.update = function (t, hidden) {
    for (const ln of L.lines) {
      const live = !hidden && t > ln.at - 0.4 && t < ln.end + 1.0;
      if (!live) { if (ln.shown) { ln.p.style.display = 'none'; ln.shown = false; } continue; }
      if (!ln.shown) { ln.p.style.display = ''; ln.shown = true; ln.cache = []; }
      const out = smooth(ln.end, ln.end + 0.9, t);
      ln.spans.forEach((s, j) => {
        const k = smooth(ln.w[j] - 0.1, ln.w[j] + 0.42, t);
        const o = clamp(k * (1 - out), 0, 1);
        const blur = (1 - k) * 7 + out * 5;
        const y = (1 - k) * 0.32 - out * 0.45;
        const key = (o * 100 | 0) + ':' + (blur * 10 | 0) + ':' + (y * 100 | 0);
        if (ln.cache[j] === key) return;
        ln.cache[j] = key;
        s.style.opacity = o.toFixed(3);
        s.style.filter = blur > 0.05 ? `blur(${blur.toFixed(2)}px)` : 'none';
        s.style.transform = `translateY(${y.toFixed(3)}em)`;
      });
    }
  };
})();
